module.exports = __webpack_public_path__ + "static/media/Start-Business.16af69b8.png";